class SiteEvents {
	static get IMAGEBUDDY_TRIGGER_UPDATE() {
		return 'imagebuddy-trigger-update';
	}

	static imageBuddyUpdate(opts = {}) {
		jQuery(window).trigger(this.IMAGEBUDDY_TRIGGER_UPDATE, opts);
	}
}

export default SiteEvents;
